import React, { useEffect, useState } from 'react';
import '../../styles/components/MyJobsList/TrainingCard.scss';
import useMoengage from '../../hooks/useMoengage';
import warningIcon from '../../assets/tc_warning.svg';

function TrainingCard({ trainingInfo = {} }) {
  const trackEvent = useMoengage()[1];

  useEffect(() => {
    console.log(trainingInfo);
  }, []);

  const trainingBtnClick = () => {
    trackEvent("client_training_button_clicked", {
      client: trainingInfo.appName
    })
  }

  return (
    <div className="training-card-parent">
      <div className="tc-header disp-flex aib">
        <div className="tc-header-img-div">
          <img className="warning-img" src={warningIcon} alt="Complete training" />
        </div>

        <div className="tc-header-txt">Complete your training</div>
      </div>

      <div className="tc-body disp-flex">
        <div>
          Install the{' '}
          <span className="app-img-div">
            <img src={trainingInfo.appIcon} alt="app-img" />
          </span>{' '}
          <span style={{ color: trainingInfo.appColor, 'font-weight': 700 }}>
            {trainingInfo.appName}
          </span>{' '}
          & Start your training
        </div>
      </div>

      <div className="start-btn">
        <a href={trainingInfo.appUrl} className="hyperlink-anchor">
          <button type="button" className="btn-fill" onClick={trainingBtnClick()}>
            Start Training
          </button>
        </a>
      </div>
    </div>
  );
}

export default TrainingCard;
